import { formatPeriod, periodParts, type PeriodDate, type PeriodOptions } from "@vidario/domain";
import { type ReactElement } from "react";

const DATE_CLASS = "tabular-nums text-xs font-semibold tracking-wide text-text-tertiary";

function PeriodDateText({ value }: { value: PeriodDate }): ReactElement {
  const text = value.spoken ?? value.text;
  return value.dateTime ? <time dateTime={value.dateTime}>{text}</time> : <>{text}</>;
}

/** A career or education period („03/2022 – heute", „03/2022 – unbekannt"), or nothing (#149, #157).
 * Screen readers get „03/2022 bis heute" instead of the dash, which they skip or
 * mangle; that version can't be selected, so a copied period has no stray „bis". */
export function PeriodLabel({
  from,
  to,
  openEnd,
}: { from: string; to: string } & PeriodOptions): ReactElement | null {
  const options: PeriodOptions = openEnd ? { openEnd } : {};
  const p = periodParts(from, to, options);
  if (!p) return null;
  return (
    <div className={DATE_CLASS}>
      <span aria-hidden="true">{formatPeriod(from, to, options)}</span>
      <span className="sr-only select-none">
        {p.lead && <>{p.lead} </>}
        {p.from && <PeriodDateText value={p.from} />}
        {p.from && p.to && " bis "}
        {p.to && <PeriodDateText value={p.to} />}
      </span>
    </div>
  );
}
